export const getMessengerParam = () => {
  const subscriptionId = typeof localStorage !== 'undefined' ? localStorage.getItem('cleverpush-subscription-id') || '' : '';
  if (subscriptionId && window.btoa) {
    try {
      return window.btoa(JSON.stringify({ connSubId: subscriptionId }));
    } catch (ignored) {}
  }
  return '';
};
